import { render, staticRenderFns } from "./Motor.vue?vue&type=template&id=be1725fa&scoped=true&"
import script from "./Motor.vue?vue&type=script&lang=js&"
export * from "./Motor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1725fa",
  null
  
)

export default component.exports